<script lang="ts">
  import { auth } from "$lib/stores/auth.svelte";
  import { api } from "$lib/api/client";
  import { navigate } from "$lib/router.svelte";

  type UseCase = { key: string; emoji: string; title: string; desc: string; wsName: string };
  const useCases: UseCase[] = [
    { key: "personal", emoji: "🧑", title: "Só eu mesmo", desc: "Controle pessoal. Foco em gastos do dia a dia, assinaturas e metas.", wsName: "Minha Carteira" },
    { key: "family", emoji: "👨‍👩‍👧", title: "Eu e minha família", desc: "Compartilhado com cônjuge ou família. Workspaces separados por pessoa.", wsName: "Finanças da Família" },
    { key: "business", emoji: "💼", title: "Meu negócio", desc: "PF + PJ separados. Centros de custo, fornecedores, exportação OFX.", wsName: "Meu Negócio" },
  ];

  let selected = $state("personal");
  let saving = $state(false);

  async function proceed() {
    saving = true;
    try {
      // Salvar persona no perfil
      await api("/me", { method: "PATCH", body: JSON.stringify({ persona: selected }) });
      // Renomear workspace padrão de acordo com a escolha
      const ws = auth.workspaces[0];
      const uc = useCases.find(u => u.key === selected)!;
      if (ws) {
        await api(`/workspaces/${ws.id}`, { method: "PATCH", body: JSON.stringify({ name: uc.wsName }) });
      }
    } catch {
      // Não bloquear se falhar
    } finally {
      saving = false;
      // Força onboarding na próxima tela (remove flag se existir)
      localStorage.removeItem("takite.onboarded");
      navigate("/dashboard");
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center px-4 py-12">
  <div class="w-full max-w-lg space-y-6">
    <!-- Header -->
    <div class="text-center space-y-2">
      <div class="text-4xl">🎉</div>
      <h1 class="text-2xl font-bold">Conta criada! Bem-vindo(a), {auth.user?.name?.split(" ")[0] ?? ""}!</h1>
      <p class="text-muted text-sm">Como você quer usar o TáKite?</p>
    </div>

    <!-- Opções -->
    <div class="space-y-3">
      {#each useCases as uc}
        <button
          class="w-full rounded-xl border p-4 text-left flex items-center gap-4 transition-all"
          style="background: var(--surface); border-color: {selected === uc.key ? 'var(--brand)' : 'var(--border)'}; box-shadow: {selected === uc.key ? '0 0 0 1px var(--brand)' : 'none'}"
          onclick={() => selected = uc.key}
        >
          <div class="text-3xl flex-none">{uc.emoji}</div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold">{uc.title}</div>
            <div class="text-xs text-muted mt-0.5">{uc.desc}</div>
          </div>
          <div class="flex-none w-5 h-5 rounded-full border-2 flex items-center justify-center"
               style="border-color: {selected === uc.key ? 'var(--brand)' : 'var(--border)'}">
            {#if selected === uc.key}
              <div class="w-2.5 h-2.5 rounded-full" style="background: var(--brand)"></div>
            {/if}
          </div>
        </button>
      {/each}
    </div>

    <!-- CTA -->
    <button class="btn-primary w-full py-3 text-base" onclick={proceed} disabled={saving}>
      {saving ? "Configurando…" : "Começar →"}
    </button>

    <p class="text-center text-xs text-muted">
      Pode mudar isso depois em Configurações → Perfil de uso
    </p>
  </div>
</div>
